import React from "react";
import { PageHeader } from "../components/Shared";
import { useLang } from "../context/LanguageContext";

const LegalPage = ({ doc }) => {
  const { t } = useLang();
  const data = t.LEGAL[doc];
  const email = t.FOOTER.contact.email;

  return (
    <div>
      <PageHeader eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />
      <section className="bg-white py-10">
        <div className="mx-auto max-w-3xl px-6 pb-16">
          <p className="text-sm text-slate-400">{data.updated}</p>
          {data.sections.map((s) => (
            <div key={s.title} data-testid={`legal-section-${data.sections.indexOf(s)}`} className="mt-10">
              <h2 className="text-xl font-bold text-slate-900">{s.title}</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-600">{s.body}</p>
            </div>
          ))}
          <div className="mt-12 rounded-2xl border border-slate-200 bg-slate-50 p-6 text-[15px] text-slate-700">
            {t.LEGAL.contactLabel}{" "}
            <a data-testid="legal-contact-email" href={`mailto:${email}`} className="font-semibold text-blue-700 hover:text-blue-800">
              {email}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export const Privacy = () => <LegalPage doc="privacy" />;
export const Terms = () => <LegalPage doc="terms" />;
